import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPendingAgreements } from 'services/AgreementsService'

export const usePendingAgreementsQuery = (isEnabled = true) => {
  return useQuery(reactQueryKeys.pendingAgreements(), getPendingAgreements, {
    enabled: isEnabled,
    onError: (error: unknown) => {
      logSentryError('Error: usePendingAgreementsQuery', error)
    },
  })
}
